'use strict';

module.exports = {
  name: '使用者群組資料',
  schema: {
    type: 'Object',
    contents: {
      account: {
        type: 'String',
        name: '群組名稱',
        unique: true
      },
      authority: {
        type: 'Object'
      }
    }
  },
  index: {
    primary: {
      key: {
        account: 1
      },
      unique: true
    }
  },
  ui: {
    list: {
      columns: [{ key: 'account', width: 250 }]
    },
    editor: {
      groups: [{
        name: '',
        rows: [[{ key: 'account' }]]
      }]
    }
  }
};


//////////////////
// WEBPACK FOOTER
// ./~/coact/models/groups.js
// module id = 1746
// module chunks = 0